export default "__VITE_ASSET__DEtgMcSu__"